import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoMenu from "./../services/bao-menu";
import baoRouter from "./../services/bao-router";
import BaoDialog from "./../factories/bao-dialog";
import finitoService from "./../services/finito-service";
import SubscriptionViewModel from "./../factories/subscription-view-model";
import "./../bindings/filtering";
function SummaryReportViewModel(tabPage) {
    var self = this;
    SubscriptionViewModel.call(self, tabPage);
    self.Infos = ko.observableArray();
    self.PageIndex = ko.observable(0);
    self.PageSize = ko.observable(20);
    self.TotalRows = ko.observable();
    self.Sorting = ko.observableArray();
    self.Selection = ko.observableArray();
    self.CustomFilter = ko.observable({});
    self.init = function () {
        self.TabPage.IsLoading(true);
        return self.getAll();
    };
    self.loaded = function () {
        var def = $.Deferred();
        self.subscribe(self.Sorting, function () {
            self.getAll();
        });
        self.subscribe(self.CustomFilter, function () {
            self.getAll();
        });
        self.subscribe(self.PageIndex, function () {
            self.getAll();
        });
        self.registerMenuClick();
        self.TabPage.IsLoading(false);
        def.resolve();
        return def.promise();
    };
    self.BeforeClose = function (fn) {
        fn();
    };
    self.ToHashObject = function (customFilter) {
        var returnValue = [];
        for (var f in customFilter) {
            returnValue.push({
                Key: f,
                Value: ko.unwrap(customFilter[f])
            });
        }
        return returnValue;
    };
}
;
Bao.inherit(SummaryReportViewModel, SubscriptionViewModel);
SummaryReportViewModel.prototype.link = function (info) {
    baoRouter.setHash("Report/" + info.ReportId() + "/Info/" + info.InfoId());
};
SummaryReportViewModel.prototype.getAll = function () {
    var self = this;
    self.TabPage.IsLoading(true);
    var customFilter = self.ToHashObject(ko.unwrap(self.CustomFilter));
    return Bao.post("SummaryReport/GetAll", JSON.stringify({
        id: self.TabPage.ObjectId(),
        pageIndex: self.PageIndex(),
        pageSize: self.PageSize(),
        sorting: self.Sorting(),
        customfilter: customFilter
    })).then(function (result) {
        ko.map.fromJS(result, self);
        self.TabPage.Title(self.Model.ReportShortTitle());
        self.TabPage.ToolTip(self.Model.ReportTitle());
        self.TabPage.IsLoading(false);
    });
};
SummaryReportViewModel.prototype.registerMenuClick = function () {
    var self = this;
    BaoMenu.registerEvent(function (btn) {
        if (self.TabPage != null && self.TabPage.IsActiveTab != null && self.TabPage.IsActiveTab() === true) {
            switch (btn.ActionKey().substr(self.Model.FormName().length)) {
                case "Previous":
                    self.previous();
                    break;
                case "Next":
                    self.next();
                    break;
                case "Refresh":
                    self.refresh();
                    break;
                case "Print":
                    self.print();
                    break;
            }
        }
    });
};
SummaryReportViewModel.prototype.refresh = function () {
    this.getAll();
};
SummaryReportViewModel.prototype.previous = function () {
    var self = this;
    self.TabPage.IsLoading(true);
    Bao.post("SummaryReport/GetPreviousReportId", JSON.stringify({
        id: self.Model.ReportId()
    })).then(function (previousReportId) {
        self.TabPage.ObjectId(previousReportId);
        self.getAll();
    });
};
SummaryReportViewModel.prototype.next = function () {
    var self = this;
    self.TabPage.IsLoading(true);
    Bao.post("SummaryReport/GetNextReportId", JSON.stringify({
        id: self.Model.ReportId()
    })).then(function (nextReportId) {
        self.TabPage.ObjectId(nextReportId);
        self.getAll();
    });
};
SummaryReportViewModel.prototype.print = function () {
    window.open("SummaryReport/Print/" + this.Model.ReportId());
};
export default SummaryReportViewModel;